import type { RowFormat } from 'common/types/scalarSpreadsheet';
import type { CellAnnotationConfig, CellAnnotationRowState } from './types';
import type { InheritedCellFormat } from './utils/extractFormatFromCell';

// A ScalarSpreadsheet column descriptor for the annotation popup. The `values`
// map holds per-row data keyed by row alias, matching the column-first pattern
// used elsewhere in the app (see useFundInvestmentSummarySheet).
export interface CellAnnotationSheetColumn {
  alias: string;
  header: string;
  gridType: 'number' | 'string';
  format?: RowFormat;
  width?: string;
  values: Record<string, unknown>;
}

export interface CellAnnotationSheetInitialObject {
  cellKey: string;
  inheritedFormat: InheritedCellFormat;
  config: CellAnnotationConfig;
}

export interface CellAnnotationSheetTableData {
  cellKey: string;
}

export interface CreateCellAnnotationPopupSheetParams {
  cellKey: string;
  // Snapshot of store rows captured at enumeration time. The SpreadsheetConfig
  // seeds from this snapshot; after that the sheet's own cells are the live
  // source of truth. reverseParser mirrors edits back to the store.
  initialRows: CellAnnotationRowState[];
  config: CellAnnotationConfig;
  inheritedFormat: InheritedCellFormat;
  // Width of the host cell. Used for the popup's first (value) column so the
  // value column visually aligns with the cell under it. Pass 0 to fall back
  // to a default width.
  parentWidth: number;
}

// Row 0 of rowConfig carries column headers (via hasColTitle + colTitleRow: 0).
export const TITLE_ROW_ALIAS = 'cell_annotation_title';
// Data rows are aliased by entry position so column.values[alias] resolves.
export const ENTRY_ROW_ALIAS_PREFIX = 'cell_annotation_entry_';
export const entryAlias = (position: number): string => `${ENTRY_ROW_ALIAS_PREFIX}${position}`;
